import { TypeRuleReference } from '@/interfaces/rules-engine';

const FIELD_TYPE_ID = 'ID';
const FIELD_TYPE_ENUMERATED = 'ENUMERATED';
const REFERENCE_TYPE_EMEDE: TypeRuleReference = 'EMEDE';
const REFERENCE_TYPE_CLIENT: TypeRuleReference = 'CLIENTE';
const REFERENCE_TYPE_TEAM: TypeRuleReference = 'TIME';
const REFERENCE_TYPE_DOCTOR: TypeRuleReference = 'MEDICO';
export const REFERENCE_TYPE_PATIENT: TypeRuleReference = 'PACIENTE';
const OVERRIDE_WEIGHT_EMEDE = '0';
const OVERRIDE_WEIGHT_CLIENT = '1';
const OVERRIDE_WEIGHT_TEAM = '2';
const OVERRIDE_WEIGHT_DOCTOR = '3';
const RULE_FILTER_TYPE_EMEDE = '1';
const RULE_FILTER_TYPE_OVERRIDE = '2';

export {
  FIELD_TYPE_ID,
  FIELD_TYPE_ENUMERATED,
  REFERENCE_TYPE_CLIENT,
  REFERENCE_TYPE_TEAM,
  REFERENCE_TYPE_DOCTOR,
  OVERRIDE_WEIGHT_EMEDE,
  OVERRIDE_WEIGHT_CLIENT,
  OVERRIDE_WEIGHT_TEAM,
  OVERRIDE_WEIGHT_DOCTOR,
  REFERENCE_TYPE_EMEDE,
  RULE_FILTER_TYPE_EMEDE,
  RULE_FILTER_TYPE_OVERRIDE,
};
